import React from "react";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";
import Divider from "../design-system/Divider";
import { USAGE_TAB } from "./constants/accountText";
import { useUsageLimits } from "./hooks/useUsageLimits";
import UsageContent from "./UsageContent";

const UsageTab = () => {
  const { usage, loadError } = useUsageLimits();

  return (
    <Box
      sx={{
        backgroundColor: colors.card.profileBackground,
        borderRadius: "16px",
        padding: "32px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        width: "100%",
        minHeight: "400px",
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: "34px",
          color: colors.neutral.white,
        }}
      >
        {USAGE_TAB.SECTION_TITLE}
      </Box>

      <Divider />

      <UsageContent usage={usage} loadError={loadError} />
    </Box>
  );
};

export default UsageTab;
